import React from 'react';
import block from 'bem-cn';
import { useSelector } from 'react-redux';

import './ActiveRequestItem.scss';

const b = block('active-request-item');

const ActiveRequestItem = ({ item, onApprove, onReject }) => {
  const locale = useSelector(state => state.locale.locale);

  return (
    <div className={b()}>
      <div className={b('top')}>
        <div className={b('cell')}>
          <div className={b('label')}>{locale.id}</div>
          <div className={b('value')}>{item.id}</div>
        </div>
        <div className={b('cell')}>
          <div className={b('label')}>{locale.userLogin}</div>
          <div className={b('value')}>{item.user_login}</div>
        </div>
        <div className={b('cell')}>
          <div className={b('label')}>{locale.date}</div>
          <div className={b('value')}>{item.created_at}</div>
        </div>
      </div>

      <div className={b('bottom')}>
        <div className={b('amount')}>
          <div className={b('label')}>{locale.withdrawalAmount}:</div>
          <div className={b('value')}>{item.amount}</div>
        </div>
        <div className={b('buttons')}>
          <button type="button" className={b('confirm')} onClick={() => onApprove(item.id)}>
            {locale.approve.toUpperCase()}
          </button>
          <button type="button" className={b('reject')} onClick={() => onReject(item.id)}>
            {locale.reject.toUpperCase()}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ActiveRequestItem;
